































































































































































































































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */

import { LineItem } from "@/models/order/order";
import { FinishDisplayName, FinishHandle } from "@/models/products/finish";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import Swatch from "../products/Swatch.vue";
import {
  getFinishName,
  getFinialFinishDisplayName,
  priceLevelMultiplier
} from "@/utility/helpers";
import {
  Fringe,
  Valance,
  getFringeDisplayName,
  getValanceDisplayName,
  FinialFinishType
} from "@/models/configurator/configurator_options";
import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { GlobalGetters } from "@/store/modules/global/types";

@Component
export default class CartModal extends Vue {
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMultiplier))
  multiplier!: any;
  @Prop() cartInfo!: {
    qty?: number;
    model: string;
    productline?: string;
    name?: string;
    finish?: FinishHandle;
    fabric?: Swatch[];
    options?: object;
    cost?: number;
    quickshipList?: LineItem[];
    accessoryList?: LineItem[];
    fringe?: Fringe;
    fringeFabric?: any[];
    sku: string;
    valance?: Valance;
    valanceFabric?: any[];
    bindingFabric?: any;
    undersideFabric?: any;
    finial?: string;
    finialFinish?: FinialFinishType | null;
    bottomPole?: string;
    rib?: string;
  };

  get multiplierDisplay(): string {
    if (!this.multiplier || typeof this.multiplier !== "object") return "—";
    return priceLevelMultiplier(this.multiplier.discountpct).toString();
  }

  protected getFringeDisplayName = getFringeDisplayName;
  protected getValanceDisplayName = getValanceDisplayName;
  protected getFinialFinishDisplayName = getFinialFinishDisplayName;

  @Watch("finish")
  private getFinishName(stringHandle: FinishHandle): FinishDisplayName {
    return getFinishName(stringHandle);
  }
}
